module.exports = __webpack_public_path__ + "static/media/narravero.9a44b87a.png";